import "./content-preview-block.scss";